import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "../ui/button";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("rfl_cookie_ok");
    if (!accepted) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("rfl_cookie_ok", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-[60] bg-white rounded-xl shadow-2xl border border-gray-100 p-5 animate-fade-up">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-lg bg-gold/15 flex items-center justify-center flex-shrink-0">
          <Cookie className="h-5 w-5 text-gold-dark" />
        </div>
        <div>
          <h4 className="font-semibold text-navy">Cookie Use</h4>
          <p className="text-sm text-gray-600 mt-1">
            We use cookies to ensure a smooth browsing experience. By continuing
            we assume you accept the use of cookies.
          </p>
          <div className="mt-3 flex gap-2">
            <Button onClick={accept} className="bg-navy hover:bg-navy-light text-white h-9 px-5 text-sm">
              Accept
            </Button>
            <Button variant="ghost" onClick={accept} className="text-gray-500 h-9 px-3 text-sm">
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
